"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = exports.getTrackingFeatureFlag = exports.getHeadSnippet = exports.getBodySnippet = void 0;
var CLIENT = typeof window !== 'undefined';
var _require = require('../consts'),
  GTM_DATALAYER_WINDOW_KEY = _require.GTM_DATALAYER_WINDOW_KEY,
  TRACKING_LIBRARY_LOAD_RETRY_LIMIT = _require.TRACKING_LIBRARY_LOAD_RETRY_LIMIT,
  TRACKING_LIBRARY_LOAD_INTERVAL = _require.TRACKING_LIBRARY_LOAD_INTERVAL;
var queue = [];
var libraryLoadedRetries = 0;
var libraryLoadedInterval;
var queueBeingProcessed = false;
var addToQueue = function addToQueue(trackMethod, data) {
  queue.push({
    trackMethod: trackMethod,
    data: data
  });
};
var processQueue = function processQueue() {
  if (queueBeingProcessed) {
    return;
  }
  queueBeingProcessed = true;

  // Clear the interval
  clearInterval(libraryLoadedInterval);
  while (queue.length > 0) {
    var _queue$shift = queue.shift(),
      trackMethod = _queue$shift.trackMethod,
      data = _queue$shift.data;

    // Call the track method
    callGtmTrack(trackMethod, data);
  }
  queueBeingProcessed = false;
};
var callGtmTrack = function callGtmTrack(trackMethod, data) {
  if (Array.isArray(data)) {
    data.forEach(function (event) {
      return window[GTM_DATALAYER_WINDOW_KEY].push(event);
    });
  } else {
    window[GTM_DATALAYER_WINDOW_KEY].push(data);
  }
};
var isGTMLibraryLoaded = function isGTMLibraryLoaded() {
  return window && window[GTM_DATALAYER_WINDOW_KEY] && typeof window[GTM_DATALAYER_WINDOW_KEY].push === 'function';
};
var track = function track(trackMethod, data) {
  if (!CLIENT) {
    return;
  }
  var isGTMAvailable = isGTMLibraryLoaded();
  if (!isGTMAvailable) {
    addToQueue(trackMethod, data);
    if (!libraryLoadedInterval) {
      libraryLoadedInterval = setInterval(function () {
        isGTMAvailable = isGTMLibraryLoaded();
        if (isGTMAvailable) {
          processQueue();
        }
        libraryLoadedRetries++;
        if (libraryLoadedRetries >= TRACKING_LIBRARY_LOAD_RETRY_LIMIT) {
          clearInterval(libraryLoadedInterval);
        }
      }, TRACKING_LIBRARY_LOAD_INTERVAL);
    }
    return;
  }
  processQueue();
  callGtmTrack(trackMethod, data);
};
exports.track = track;
var getTrackingFeatureFlag = function getTrackingFeatureFlag() {
  return 'common.gtm';
};
exports.getTrackingFeatureFlag = getTrackingFeatureFlag;
var getBodySnippet = function getBodySnippet() {
  var _process;
  var GTM_CONTAINER_ID = (_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.GTM_CONTAINER_ID;
  if (!GTM_CONTAINER_ID) {
    return '';
  }
  return "\n  <noscript><iframe src='https://www.googletagmanager.com/ns.html?id=".concat(GTM_CONTAINER_ID, "' height='0' width='0' style='display:none;visibility:hidden'></iframe></noscript>\n  ");
};
exports.getBodySnippet = getBodySnippet;
var getHeadSnippet = function getHeadSnippet() {
  var _process2;
  var GTM_CONTAINER_ID = (_process2 = process) === null || _process2 === void 0 || (_process2 = _process2.env) === null || _process2 === void 0 ? void 0 : _process2.GTM_CONTAINER_ID;
  if (!GTM_CONTAINER_ID) {
    return '';
  }
  return "\n  <script type=\"text/javascript\">\n  window.".concat(GTM_DATALAYER_WINDOW_KEY, " = window.").concat(GTM_DATALAYER_WINDOW_KEY, " || [];\n  (function(w,d,s,l,i){\n  w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});\n  var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n  j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;\n  f.parentNode.insertBefore(j,f);\n  })(window,document,'script','").concat(GTM_DATALAYER_WINDOW_KEY, "','").concat(GTM_CONTAINER_ID, "');\n  </script>\n  ");
};
exports.getHeadSnippet = getHeadSnippet;